<template>
  <div class="form-group">
    <label v-bind:for="id" v-if="label" class="form-label">{{ label }}
      <i v-if="parseBoolean(required)" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <div v-bind:class="{'is-invalid': invalid}">
      <i v-if="loading" class="fa fa-loading-black-16"></i>
      <slot v-else=""/>
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot name="help"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "input-custom",
  computed: {
    help: function () {
      return !!this.$slots.help;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  props: ["id", "errors", "label", "language", "required", "loading"],
}
</script>
